import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminUserList = () => {
    const [data, setData] = useState([]);
    const [courses, setCourses] = useState([]); // Yeni eklendi: Kursları tutacağımız state
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation()



    const columns = React.useMemo(
        () => [
            {
                Header: t("namesurname"),
                Footer: t("namesurname"),
                accessor: 'name',
            },
            {
                Header: t("email"),
                Footer: t("email"),
                accessor: 'email',
            },
            {
                Header: t("createdAt"),
                Footer: t("createdAt"),
                accessor: 'createdAt',
            },
            {
                Header: t("expiryDate"),
                Footer: t("expiryDate"),
                accessor: 'expiryDate',
            },
            {
                Header: "aktif kurs",
                Footer: "aktif kurs",
                accessor: "activeCourse",
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: (originalRow) => (
                    <span
                        className={`btn btn-sm ${originalRow.isTrialRaw ? "btn-warning" : "btn-success"}`}
                    >
                        {originalRow.isTrialRaw ? t('passive') : t('active')}
                    </span>
                ),
                id: 'isTrial',
            },
            {
                Header: "Aksiyonlar",
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex align-items-center gap-2">
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            Kullanıcı Bilgilerini Düzenle
                        </button>
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => handleEditEducational(originalRow)}
                        >
                            Eğitim Bilgilerini Düzenle
                        </button>
                    </div>
                ),
                id: 'actionEdit',
                Footer: "Aksiyonlar",
            },
        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/admin/edituser/" + row['id'];
    }

    const handleEditEducational = (row) => {
        window.location.href = "/admin/editusereducational/" + row['id'];
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                // YENİ EKLENEN KISIM: Kullanıcılardan önce kurs listesini çekiyoruz
                let fetchedCourses = [];
                try {
                    const courseUrl = `${API_BASE_URL}/admin/CourseManager/GetCourses`; // API_BASE_URL kullanımı
                    const courseRes = await axios({
                        method: 'GET',
                        url: courseUrl,
                        headers: headerss
                    });
                    if (courseRes.status === 200 && courseRes.data['success']) {
                        fetchedCourses = courseRes.data['data'];
                        setCourses(fetchedCourses);
                    }
                } catch (error) {
                    console.error("Kurslar çekilirken bir hata oluştu: ", error);
                }


                let url = `${API_BASE_URL}/admin/User/GetUsers`; // API_BASE_URL kullanımı
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {

                            for (let i = 0; i < res.data['data'].length; i++) {
                                let a = ""
                                if (res.data['data'][i]['user']['isTrial']) {
                                    a = t('passive')
                                }
                                else {
                                    a = t('active')
                                }
                                if (res.data['data'][i]['user']['isStudent']) {
                                    if (res.data['data'][i]['user']['isInvidual']) {
                                        const d = new Date(res.data.data[i].user.expiryDate);
                                        const expiryDateTR = d.toLocaleDateString("tr-TR");
                                        const dd = new Date(res.data.data[i].user.createdAt);
                                        const createdDataTR = dd.toLocaleDateString("tr-TR");

                                        // YENİ EKLENEN KISIM: Aktif kursu ID'den bulup ismini çıkarıyoruz
                                        let activeCourseName = "-";
                                        const edu = res.data['data'][i]['educational'];

                                        if (edu && edu.courseId) {
                                            const matchedCourse = fetchedCourses.find(c => c.id === edu.courseId);
                                            if (matchedCourse) {
                                                // courseName içindeki HTML etiketlerini (örn: <sup>) Datatable'da düzgün görünmesi için temizliyoruz
                                                activeCourseName = matchedCourse.courseName.replace(/<\/?[^>]+(>|$)/g, "");
                                            }
                                        }

                                        data.push({
                                            "id": res.data['data'][i]['user']['id'],
                                            "name": res.data['data'][i]['user']['fullName'],
                                            "email": res.data['data'][i]['user']['username'],
                                            "SchoolId": res.data['data'][i]['detail']['schoolId'],
                                            "isTrial": a,
                                            "isTrialRaw": res.data['data'][i]['user']['isTrial'],
                                            "expiryDate": expiryDateTR,
                                            "createdAt": createdDataTR,
                                            "sectionName": res.data['data'][i]['detail']['sectionName'],
                                            "activeCourse": activeCourseName, // YENİ EKLENEN DEĞER
                                        })
                                    }
                                }
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err?.message || "Bir hata oluştu");
            }
            setLoading(false);
        }
        fetchData();

    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>{t('userList')}</h1>
            </div>
            <h4>{msg}</h4>
            {loading && <div>Veriler Yükleniyor!</div>}

            {!loading && (
                <div>
                    <Datatable data={data} columns={columns} tableBaslik={t('userList')} />
                </div>
            )}
        </div>
    );
};
export default AdminUserList;